import _regeneratorRuntime from "C:\\Users\\nanma\\Documents\\GitHub\\star\\node_modules\\@babel\\runtime/regenerator";
import _asyncToGenerator from "C:\\Users\\nanma\\Documents\\GitHub\\star\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _construct from "C:\\Users\\nanma\\Documents\\GitHub\\star\\node_modules\\@babel\\runtime/helpers/esm/construct";
import _toConsumableArray from "C:\\Users\\nanma\\Documents\\GitHub\\star\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "C:\\Users\\nanma\\Documents\\GitHub\\star\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\nanma\\Documents\\GitHub\\star\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _slicedToArray from "C:\\Users\\nanma\\Documents\\GitHub\\star\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "C:\\Users\\nanma\\Documents\\GitHub\\star\\node_modules\\@babel\\runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject9() {
  var data = _taggedTemplateLiteral(["## Dependencies"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["## Model Resolution\n\nWe use the term *resolve* to refer to the process of taking a list\nof line segments (as pairs of vectors), and associating a strut shape,\nlength, and orientation with each."]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["<div><div style=\"font-weight:bold\">", "</div><div>", "</div><div>", "</div><div>", "</div><div>", "</div></div>"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["<div><div>", "</div><div>", "</div><div>", "</div></div>"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["<span>", "", "</span>"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["## Useful Input Controls\n\nThis section contains some reusable input controls for Zome numbers,\nZome vectors, etc."]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["## vZomeRenderer"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n<table><tr>\n<td>\n", "\n</td>\n<td>The shape models used to render these purple struts and balls\nare imported from vZome.  It is possible to hand-code your own shape models,\nbut we are not quite ready to document it.</span>\n</td></tr></table>"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["# WIP Observable vZome\n\nThis notebook represents a new embodiment of vZome, native to the web,\nand reimagined in Javascript.  It is a collaborative effort between [Jacob Rus](https://beta.observablehq.com/@jrus) and \n[Scott Vorthmann](https://beta.observablehq.com/@vorth), with Jacob providing\nmost of the fresh ideas and clever, clear implementation.\n\nFor now, this notebook gives you a handy viewer for [vZome](http://vzome.com) models, based\non [Three.js](https://threejs.org/), but no equivalent of the\n[desktop vZome](http://vzome.com/home/index/vzome-60/)\napplication for interactively building models.  However, we\nare providing a completely transparent set of APIs for generating\nmodels using Javascript code.  Observable vZome is far more open-ended\nthan the desktop application, which still has its place as a way\nto interactively create models."]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

// https://observablehq.com/@vorth/wip-observable-vzome@3208
import define1 from "../@vorth/wip-importing-vzome-shapes.js";
import define2 from "../@jrus/zome-arithmetic.js";
import define3 from "../@jashkenas/inputs.js";
export default function define(runtime, observer) {
  var main = runtime.module();
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject());
  });
  main.variable(observer()).define(["html", "vZomeRenderer", "testResolve", "icosahedral_solid_connectors_shapes"], function (html, vZomeRenderer, testResolve, icosahedral_solid_connectors_shapes) {
    return html(_templateObject2(), vZomeRenderer(testResolve, icosahedral_solid_connectors_shapes, 500));
  });
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject3());
  });
  main.variable(observer("vZomeRenderer")).define("vZomeRenderer", ["icosahedral_solid_connectors_shapes", "width", "Geometries", "colors", "meshGroup", "vZomeCanvas"], function (icosahedral_solid_connectors_shapes, width, Geometries, colors, meshGroup, vZomeCanvas) {
    return function vZomeRenderer(model) {
      var shapes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : icosahedral_solid_connectors_shapes;
      var canvasWidth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : width;
      var aspect = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 8 / 5;
      var solidParts = new Geometries(shapes, colors);
      var group = meshGroup(model, solidParts);
      return vZomeCanvas(group, {
        renderWidth: canvasWidth,
        aspect: aspect
      });
    };
  });
  main.variable(observer("vZomeCanvas")).define("vZomeCanvas", ["width", "THREE", "invalidation"], function (width, THREE, invalidation) {
    return function (meshGroup, config) {
      var _config$renderWidth = config.renderWidth,
          renderWidth = _config$renderWidth === void 0 ? width : _config$renderWidth,
          _config$aspect = config.aspect,
          aspect = _config$aspect === void 0 ? 8 / 5 : _config$aspect,
          _config$orbitControl = config.orbitControl,
          orbitControl = _config$orbitControl === void 0 ? true : _config$orbitControl;
      var scene = new THREE.Scene();
      scene.background = new THREE.Color(0xffffff);
      scene.add(meshGroup);
      var lights = scene.lights = {};
      lights.ambient = new THREE.AmbientLight(0x444444, .8);
      lights.spot = new THREE.SpotLight(0x888888, .4);
      lights.spot.position.set(200, 500, 0);
      lights.hemiLight = new THREE.HemisphereLight(0xefede8, 0x727248, .6);
      var fov = 30;
      var near = 1;
      var far = 4000;
      var camera = new THREE.PerspectiveCamera(fov, aspect, near, far);
      camera.position.z = 500;
      camera.add(lights.hemiLight);
      camera.add(lights.ambient);
      camera.add(lights.spot);
      scene.add(camera);
      var renderer = new THREE.WebGLRenderer({
        antialias: true,
        preserveDrawingBuffer: true
      });
      renderer.setSize(renderWidth, renderWidth / aspect);
      renderer.setPixelRatio(devicePixelRatio);
      invalidation.then(function () {
        return renderer.dispose();
      });
      var controls;

      if (orbitControl) {
        controls = new THREE.OrbitControls(camera, renderer.domElement); // controls .rotateSpeed = 5;
        // controls .zoomSpeed = 2.5;

        invalidation.then(function () {
          return renderer.dispose(), controls.dispose();
        });
        controls.addEventListener("change", function () {
          renderer.render(scene, camera);
        });
      }

      function animate() {
        requestAnimationFrame(animate);
        controls && controls.update();
      }

      animate();
      renderer.render(scene, camera);
      return renderer.domElement;
    };
  });
  main.variable(observer("defaultCanvas")).define("defaultCanvas", ["THREE", "width", "invalidation"], function (THREE, width, invalidation) {
    return function defaultCanvas(group, canvasWidth) {
      var aspect = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 8 / 5;
      var scene = new THREE.Scene();
      scene.background = new THREE.Color(0xffffff);
      scene.add(group);
      var lights = scene.lights = {};
      lights.ambient = new THREE.AmbientLight(0x444444, .8);
      lights.spot = new THREE.SpotLight(0x888888, .4);
      lights.spot.position.set(200, 500, 0);
      lights.hemiLight = new THREE.HemisphereLight(0xefede8, 0x727248, .6);
      var fov = 30;
      var near = 1;
      var far = 4000;
      var camera = new THREE.PerspectiveCamera(fov, aspect, near, far);
      camera.position.z = 500;
      camera.add(lights.hemiLight);
      camera.add(lights.ambient);
      camera.add(lights.spot);
      scene.add(camera);
      var renderer = new THREE.WebGLRenderer({
        antialias: true,
        preserveDrawingBuffer: true
      });
      var renderWidth = canvasWidth || width;
      renderer.setSize(renderWidth, renderWidth / aspect);
      renderer.setPixelRatio(devicePixelRatio);
      var controls = new THREE.OrbitControls(camera, renderer.domElement);
      controls.staticMoving = true; // controls .rotateSpeed = 5;
      // controls .zoomSpeed = 2.5;

      invalidation.then(function () {
        return controls.dispose(), renderer.dispose();
      });
      controls.addEventListener("change", function () {
        renderer.render(scene, camera);
      });

      function animate() {
        requestAnimationFrame(animate);
        controls.update();
      }

      animate();
      renderer.render(scene, camera);
      return renderer.domElement;
    };
  });
  main.variable(observer("meshGroup")).define("meshGroup", ["Geometries", "icosahedral_solid_connectors_shapes", "colors", "THREE", "grfloat", "createPanelGeometry"], function (Geometries, icosahedral_solid_connectors_shapes, colors, THREE, grfloat, createPanelGeometry) {
    return function meshGroup(model) {
      var geometries = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Geometries(icosahedral_solid_connectors_shapes, colors);
      var group = new THREE.Object3D();
      var ballMaterial = new THREE.MeshLambertMaterial({
        color: geometries.ballColor
      });
      model.balls.contents.forEach(function (ball) {
        var mesh = new THREE.Mesh(geometries.ballGeometry, ballMaterial);
        var p = mesh.position;

        var _model$vertices$conte = model.vertices.contents[ball].map(grfloat);

        var _model$vertices$conte2 = _slicedToArray(_model$vertices$conte, 3);

        p.x = _model$vertices$conte2[0];
        p.y = _model$vertices$conte2[1];
        p.z = _model$vertices$conte2[2];
        group.add(mesh);
      });
      model.struts.forEach(function (strut) {
        var orbitName = strut.orbit;
        var color = geometries.strutColor(orbitName);
        var material = new THREE.MeshLambertMaterial({
          color: color
        });
        var geometry = geometries.strutGeometry(orbitName, strut.length);

        if (geometry) {
          var mesh = new THREE.Mesh(geometry, material);
          var q = mesh.quaternion,
              p = mesh.position;

          var _model$vertices$conte3 = model.vertices.contents[strut.start].map(grfloat);

          var _model$vertices$conte4 = _slicedToArray(_model$vertices$conte3, 3);

          p.x = _model$vertices$conte4[0];
          p.y = _model$vertices$conte4[1];
          p.z = _model$vertices$conte4[2];

          var _model$quaternions$co = model.quaternions.contents[strut.orientation].map(grfloat);

          var _model$quaternions$co2 = _slicedToArray(_model$quaternions$co, 4);

          q.w = _model$quaternions$co2[0];
          q.x = _model$quaternions$co2[1];
          q.y = _model$quaternions$co2[2];
          q.z = _model$quaternions$co2[3];
          group.add(mesh);
        }
      });

      if (model.panels) {
        model.panels.forEach(function (panel) {
          var geometry = createPanelGeometry(panel, model.vertices.contents);
          var material = new THREE.MeshLambertMaterial({
            color: panel.color || colors["red"]
          });
          var mesh = new THREE.Mesh(geometry, material);
          group.add(mesh);
        });
      }

      return group;
    };
  });
  main.variable(observer("Geometries")).define("Geometries", ["createBallGeometry", "getStrutGeometry", "colors"], function (createBallGeometry, getStrutGeometry, colors) {
    return (
      /*#__PURE__*/
      function () {
        function Geometries(shapes, colors) {
          _classCallCheck(this, Geometries);

          this.colors = colors;
          this.shapes = shapes;
          this.cache = {};
          this.ballColor = colors["white"];
          this.ballGeometry = createBallGeometry(shapes.ballShape);
        }

        _createClass(Geometries, [{
          key: "strutGeometry",
          value: function strutGeometry(orbit, length) {
            return getStrutGeometry(this.cache, this.shapes, orbit, length);
          }
        }, {
          key: "strutColor",
          value: function strutColor(orbit) {
            var shape = this.shapes.strutShapes[orbit];

            if (shape) {
              return colors[shape.color];
            } else {
              return colors["white"];
            }
          }
        }]);

        return Geometries;
      }()
    );
  });
  main.variable(observer("THREEVector3")).define("THREEVector3", ["THREE", "grfloat"], function (THREE, grfloat) {
    return function THREEVector3(v) {
      return _construct(THREE.Vector3, _toConsumableArray(v.map(grfloat)));
    };
  });
  main.variable(observer("createStrutGeometry")).define("createStrutGeometry", ["scalarmul", "vectoradd", "THREE", "THREEVector3", "triangulate"], function (scalarmul, vectoradd, THREE, THREEVector3, triangulate) {
    return function createStrutGeometry(shapes, orbit, length) {
      var shape = shapes.strutShapes[orbit];
      if (!shape) return undefined;
      var endpoint = scalarmul(length, shape.prototype);
      var midpoint = scalarmul([1,, 2], endpoint);
      var vertices = shape.vertices.slice();
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = shape.tip[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var i = _step.value;
          vertices[i] = vectoradd(vertices[i], endpoint);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = shape.waist[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _i = _step2.value;
          vertices[_i] = vectoradd(vertices[_i], midpoint);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      var geometry = new THREE.Geometry();
      geometry.vertices = vertices.map(THREEVector3);
      geometry.faces = shape.polygons.reduce(function (triangles, polygon) {
        return triangles.concat(triangulate(polygon));
      }, []);
      geometry.computeFaceNormals();
      return geometry;
    };
  });
  main.variable(observer("triangulate")).define("triangulate", ["THREE"], function (THREE) {
    return function triangulate(polygon) {
      return polygon.reduce(function (tris, vertex, index, array) {
        if (index >= 2) {
          tris.push(new THREE.Face3(array[0], array[index - 1], array[index]));
        }

        return tris;
      }, []);
    };
  });
  main.variable(observer("createPanelGeometry")).define("createPanelGeometry", ["THREE", "THREEVector3", "range", "triangulate"], function (THREE, THREEVector3, range, triangulate) {
    return function createPanelGeometry(panel, vertices) {
      var geometry = new THREE.Geometry();
      geometry.vertices = panel.vertices.map(function (index) {
        return THREEVector3(vertices[index]);
      });

      var list = _toConsumableArray(range(panel.vertices.length));

      geometry.faces = triangulate(list).concat(triangulate(list.reverse()));
      geometry.computeFaceNormals();
      return geometry;
    };
  });
  main.variable(observer("createBallGeometry")).define("createBallGeometry", ["THREE", "THREEVector3", "triangulate"], function (THREE, THREEVector3, triangulate) {
    return function createBallGeometry(shape) {
      var geometry = new THREE.Geometry();
      geometry.vertices = shape.vertices.map(THREEVector3);
      geometry.faces = shape.polygons.reduce(function (triangles, polygon) {
        return triangles.concat(triangulate(polygon));
      }, []);
      geometry.computeFaceNormals();
      return geometry;
    };
  });
  main.variable(observer("getStrutGeometry")).define("getStrutGeometry", ["createStrutGeometry"], function (createStrutGeometry) {
    return function getStrutGeometry(cache, shapes, orbit, length) {
      var key = orbit + ":" + length;

      if (!cache[key]) {
        cache[key] = createStrutGeometry(shapes, orbit, length);
        console.log("Cached geometry for " + key);
      }

      return cache[key];
    };
  });
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject4());
  });
  main.variable(observer("phiPowerInput")).define("phiPowerInput", ["grpow", "slider", "numberString"], function (grpow, slider, numberString) {
    return function phiPowerInput(max) {
      // exponents: [ -max, ... 0, ... max ]
      var exponents = _toConsumableArray(Array(2 * max + 1).keys()).map(function (i) {
        return i - max;
      });

      var powers = exponents.map(function (i) {
        return grpow([, 1], i);
      });
      return slider({
        value: max,
        min: 0,
        max: 2 * max,
        step: 1,
        getValue: function getValue(n) {
          return powers[n.value];
        },
        display: function display(v) {
          return numberString(v);
        }
      });
    };
  });
  main.variable(observer("numberString")).define("numberString", function () {
    return function numberString(a) {
      var _a = _slicedToArray(a, 2),
          a0 = _a[0],
          _a$ = _a[1],
          a1 = _a$ === void 0 ? 0 : _a$,
          sign = a1 >= 0 ? '+' : '';

      return "" + a0 + sign + a1 + "\u03C6";
    };
  });
  main.variable(observer("numberInput")).define("numberInput", ["number", "phiPowerInput", "html", "grmul"], function (number, phiPowerInput, html, grmul) {
    return function numberInput(maxPower) {
      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var n = number({
        value: value
      });
      n.style.display = "inline";
      var p = phiPowerInput(maxPower);
      p.style.display = "inline";
      var element = html(_templateObject5(), n, p);

      element.oninput = function () {
        return element.value = grmul([n.value], p.value);
      };

      element.oninput();
      return element;
    };
  });
  main.variable(observer("viewof x")).define("viewof x", ["numberInput"], function (numberInput) {
    return numberInput(4, 0);
  });
  main.variable(observer("x")).define("x", ["Generators", "viewof x"], function (G, _) {
    return G.input(_);
  });
  main.variable(observer()).define(["x"], function (x) {
    return x;
  });
  main.variable(observer("vectorInput")).define("vectorInput", ["numberInput", "html"], function (numberInput, html) {
    return function vectorInput(max) {
      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [1, 0, 0];
      var x = numberInput(max, value[0]);
      var y = numberInput(max, value[1]);
      var z = numberInput(max, value[2]);
      var element = html(_templateObject6(), x, y, z);

      element.oninput = function () {
        return element.value = [x.value, y.value, z.value];
      };

      element.oninput();
      return element;
    };
  });
  main.variable(observer("quaternionInput")).define("quaternionInput", ["numberInput", "html"], function (numberInput, html) {
    return function quaternionInput(max) {
      var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      var value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [1, 0, 0, 0];
      var w = numberInput(max, value[0]);
      var x = numberInput(max, value[1]);
      var y = numberInput(max, value[2]);
      var z = numberInput(max, value[3]);
      var element = html(_templateObject7(), title, w, x, y, z);

      element.oninput = function () {
        return element.value = [w.value, x.value, y.value, z.value];
      };

      element.oninput();
      return element;
    };
  });
  main.variable(observer()).define(["quaternionInput"], function (quaternionInput) {
    return quaternionInput(3, "Enter a quaternion:");
  });
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject8());
  });
  main.variable(observer("newModel")).define("newModel", ["IndexedSet"], function (IndexedSet) {
    return function newModel() {
      return {
        vertices: new IndexedSet(),
        quaternions: new IndexedSet(),
        balls: new IndexedSet(),
        struts: [],
        panels: []
      };
    };
  });
  main.variable(observer("resolveSegments")).define("resolveSegments", ["newModel", "IndexedSet", "scalarmul", "vectorsub", "orbit2"], function (newModel, IndexedSet, scalarmul, vectorsub, orbit2) {
    return function resolveSegments(segments) {
      var model = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : newModel();
      var scale = [2, 3, 1]; // phi cubed

      var struts = new IndexedSet();
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = segments[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var segment = _step3.value;
          var startpoint = scalarmul(scale, segment[0]);
          var endpoint = scalarmul(scale, segment[1]);
          var startindex = model.vertices.add(startpoint);
          var endindex = model.vertices.add(endpoint);
          model.balls.add(startindex), model.balls.add(endindex);
          if (startindex != endindex) struts.add([startindex, endindex].sort());
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = struts.contents[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var _ref3 = _step4.value;

          var _ref2 = _slicedToArray(_ref3, 2);

          var _startindex = _ref2[0];
          var _endindex = _ref2[1];
          var _startpoint = model.vertices.contents[_startindex];
          var _endpoint = model.vertices.contents[_endindex];
          var displacement = vectorsub(_endpoint, _startpoint);

          var _orbit = orbit2(displacement),
              _orbit2 = _slicedToArray(_orbit, 4),
              orbit = _orbit2[0],
              quaternion = _orbit2[1],
              reflected = _orbit2[2],
              length = _orbit2[3];

          var quatindex = model.quaternions.add(quaternion);
          model.struts.push({
            orbit: JSON.stringify(orbit),
            orientation: quatindex,
            start: reflected ? _endindex : _startindex,
            length: length
          });
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      return model;
    };
  });
  main.variable(observer("IndexedSet")).define("IndexedSet", function () {
    return (
      /*#__PURE__*/
      function () {
        function IndexedSet() {
          _classCallCheck(this, IndexedSet);

          this.contents = [];
          this.map = new Map();
        }

        _createClass(IndexedSet, [{
          key: "add",
          value: function add(item) {
            var itemhash = JSON.stringify(item);
            var index = this.map.get(itemhash);

            if (index == null) {
              index = this.contents.length;
              this.contents.push(item);
              this.map.set(itemhash, index);
            }

            return index;
          }
        }]);

        return IndexedSet;
      }()
    );
  });
  main.variable(observer("testResolve")).define("testResolve", ["scalarmul", "icosahedral_quaternions_vzome", "quattransform", "resolveSegments", "colors"], function (scalarmul, icosahedral_quaternions_vzome, quattransform, resolveSegments, colors) {
    var v0 = scalarmul([1, 2], [[1, 2], [0, 1], [0, 0]]); // purple

    var vs = icosahedral_quaternions_vzome.map(function (q) {
      return quattransform(q, v0);
    });
    var model = resolveSegments(vs.map(function (v) {
      return [[[0], [0], [0]], v];
    }));
    model.panels.push({
      vertices: [3, 5, 7],
      color: colors["yellow"]
    });
    return model;
  });
  main.variable(observer("colors")).define("colors", function () {
    return {
      red: "#c52431",
      yellow: "#f0a901",
      blue: "#06608d",
      green: "#088d32",
      orange: "#e76500",
      purple: "#7a42ab",
      black: "#28282a",
      white: "#eef1f7",
      olive: "#746801",
      lavender: "#907fe3",
      maroon: "#831147",
      rose: "#fc6aab",
      navy: "#343088",
      brown: "#693601",
      apple: "#81bf1e",
      sand: "#bb9055",
      turquoise: "#2fae97",
      coral: "#fe8c8b",
      sulfur: "#c4e751",
      cinnamon: "#90380e",
      spruce: "#0c5437",
      magenta: "#db2976",
      slate: "#667e99",
      mauve: "#925283",
      ivory: "#e5ddb9"
    };
  });
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject9());
  });
  var child1 = runtime.module(define1);
  main.import("icosahedral_solid_connectors_shapes", child1);
  main.import("icosahedral_lifelike_connectors_shapes", child1);
  var child2 = runtime.module(define2);
  main.import("vectoradd", child2);
  main.import("grneg", child2);
  main.import("grfloat", child2);
  main.import("grmul", child2);
  main.import("grdiv", child2);
  main.import("grsub", child2);
  main.import("simplify3", child2);
  main.import("grpow", child2);
  main.import("scalarmul", child2);
  main.import("spread", child2);
  main.import("vectorsub", child2);
  main.import("icosahedral_quaternions_vzome", child2);
  main.import("orbit2", child2);
  main.import("range", child2);
  main.import("deduplicate", child2);
  main.import("quattransform", child2);
  main.import("quatconj", child2);
  var child3 = runtime.module(define3);
  main.import("select", child3);
  main.import("slider", child3);
  main.import("color", child3);
  main.import("number", child3);
  main.variable(observer("THREE")).define("THREE", ["require"],
  /*#__PURE__*/
  function () {
    var _ref4 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(require) {
      var THREE;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return require("three@0.96/build/three.min.js");

            case 2:
              THREE = window.THREE = _context.sent;
              _context.next = 5;
              return require("three@0.96/examples/js/controls/OrbitControls.js").catch(function () {});

            case 5:
              return _context.abrupt("return", THREE);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref4.apply(this, arguments);
    };
  }());
  return main;
}